// 공통 스타일 변수
export const mainColor = '#FE531F';
export const mainBgColor = '#eee';
export const mainPadd = '0 1.5rem';
export const mainPadd2 = '0 1.5rem 1.5rem';
export const mainPaddBody = '8vh 1.5rem 1.5rem';
export const mainHeaderHeight = '8vh';
export const mainBodyHeight = '92vh';
export const pageCommonPadd = '1rem 0 0';
export const pageCommonPadd2 = '1rem 0';
export const pageEmptyFontSize = 'max(1.2vw, 20px)';
export const pageH1FontSize = 'max(1.5vw, 25px)';
export const pageEH2FontSize = 'max(1.2vw, 16px)';
export const pageEH3FontSize = 'max(1vw, 12px)';
export const pageCommonGap1 = '1.5rem';
export const pagePaddTopH = "8vh";
export const compCommonPadd = 'max(1vw, 0.5rem)';
export const compBgColor = '#fff';
export const compBorderRadius = '0.5rem';
export const compBorderColor = '1px solid #d9d9d9';

// 공통 메시지 변수

// 상품 등록 페이지 스타일 변수
export const registerHeight = '100vh';
export const registerFontSize = 'max(1vw, 20px)';
export const registerGap1 = '1rem';
export const registerGap2 = '0.5rem';

// 통계 상세 페이지 스타일 변수
export const statDetailFontColor = "#B7B7B7";